import React from 'react';

import microsoft from '../assets/images/microsoftLogo.png';
import foundationImage from '../assets/images/foundationLogo.png';

function Footer() {
  return (
    <div className='flex justify-center flex-wrap items-center w-full h-[auto] bg-[#041a45] text-[16px] leading-[24px] text-start tracking-[normal]'>
      {/* newsletter */}
      <div className='h-auto w-full flex-wrap md:flex-no-wrap flex justify-between items-center md:w-[1140px] md:h-[119px] md:mx-[70px] my-[80px] text-[16px] leading-[24px] text-start text-[#232323]'>
        <div className='w-full sm:w-[380px] sm:h-[98px] p-[30px] text-[25.6px] text-start sm:leading-[38.4px] text-white'>
          Need some assistance ?{' '}
        </div>
        <form className='w-full h-auto lg:w-[760px] lg:h-[119px] flex flex-row lg:justify-center justify-center items-center flex-wrap gap-[14px]'>
          <div className='mb-6 w-[179px]'>
            <input
              type='text'
              className='form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
              id='exampleFormControlInput2'
              placeholder='Name'
            />
          </div>

          <div className='mb-6 w-[179px]'>
            <input
              type='email'
              className='form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
              id='exampleFormControlInput2'
              placeholder='Email'
            />
          </div>
          <div className='mb-6 w-[179px]'>
            <input
              type='phone'
              className='form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
              id='exampleFormControlInput2'
              placeholder='Phone'
            />
          </div>

          <div className='text-center lg:text-left mb-6'>
            <button
              type='button'
              className='inline-block md:h-[49px] px-7 py-[4px] bg-[#ecbd46] text-white font-bold text-[19.2px] leading-[28.8px] uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out text-center'
            >
              Submit
            </button>
          </div>
        </form>
        {/* end of newsletter */}
      </div>
      <div className='w-full h-[72px] flex justify-between items-center text-[16px] leading-[24px] text-start px-[30px]'>
        <div className='w-[auto] h-[72px] leading-[24px] flex justify-center items-center'>
          <img src={microsoft} className='w-[120px]' alt='microsoft logo' />
          <div className='h-[60%] w-[1px] bg-white mx-[2px]'></div>
          <img
            src={foundationImage}
            className='w-[120px]'
            alt='wootlab Foundation logo'
          />
        </div>
        <div className='text-[19.2px] text-right leading-[19.2px] text-white font-bold'>
          Anytime, anywhere learning!
        </div>
      </div>
      {/*  */}
      <div className='w-full h-[80px] flex justify-between items-center text-[16px] leading-[24px] text-start px-[30px] mb-[30px]'>
        <div className='w-[auto] h-[72px] text-[17.6px] leading-[26.4px] text-start flex justify-center items-center text-white'>
          © Microsoft & Wootlab Foundation - All Rights Reserved
        </div>
      </div>
    </div>
  );
}

export default Footer;
